/**
 * Темы оформления (E15 / ФТ-8.3).
 * Идентификаторы совпадают с `@potok/ui` THEME_IDS (default / admin).
 */

import { z } from "zod";
import { apiSuccessSchema } from "./envelope";

export const UI_THEME_IDS = ["default", "admin"] as const;
export const uiThemeIdSchema = z.enum(UI_THEME_IDS);
export type UiThemeId = z.infer<typeof uiThemeIdSchema>;

export const UI_THEME_OPTIONS = [
  { id: "default" as const, title: "Клиентская (оранжевый акцент)" },
  { id: "admin" as const, title: "Административная (зелёный акцент)" },
] as const;

export const themeSettingsSchema = z.object({
  /** Тема клиентского SPA. */
  webThemeId: uiThemeIdSchema,
  /** Тема админ-панели. */
  adminThemeId: uiThemeIdSchema,
});
export type ThemeSettings = z.infer<typeof themeSettingsSchema>;

export const updateThemeSettingsRequestSchema = themeSettingsSchema;
export type UpdateThemeSettingsRequest = z.infer<typeof updateThemeSettingsRequestSchema>;

export const themeSettingsResponseSchema = apiSuccessSchema(themeSettingsSchema);

export const DEFAULT_THEME_SETTINGS: ThemeSettings = {
  webThemeId: "default",
  adminThemeId: "admin",
};

export const THEME_ERROR_CODES = {
  INVALID: "THEME_INVALID",
} as const;
export type ThemeErrorCode = (typeof THEME_ERROR_CODES)[keyof typeof THEME_ERROR_CODES];
